// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__34Z7r","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Ygpe"};